// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SnsLine from '../_raw/ui/icon_sns_line.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SnsLine);
